import React from 'react'
import { Table, Checkbox, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import {
  setcontractTypeCheckBox,
  setContractTypeState,
  setIsCheckedState,
  setMergeAll
} from '../../../reducer/CommonSlice'
import './accountDetailsTable.scss'

const AccountDetailsTable = ({
  deSelectedAccount,
  setDeSelectedAccount,
  setSelectAllContract,
  selectedAccountDetails,
  accountsOrCorporateParents,
  setSelectedAccountDetails,
  selectedAccounts,
  setSelectedAccounts,
  showEditModal,
  paginationOnChange,
  dataSource,
  setUnselect,
  setRemoveAccountsSelection
}) => {
  const dispatch = useDispatch()
  const contractTypesOptions = useSelector((state) => state.Common.contractTypes)
  const contractTypeState = useSelector((state) => state.Common.contractTypeState)
  const scenarioType = useSelector((state) => state.Common.scenarioType)
  const allSelectedContractTypes = useSelector((state) => state.Common.allSelectedContractTypes)
  const contractTypesIds = useSelector((state) => state.Common.contractTypes)
  const paginationDetails = useSelector((state) => state.Common.IdPagination)
  const handleCheckboxChange = (e, accountId, field) => {
    const contractType = contractTypesOptions.filter((contracttype) => contracttype.label == field)
    const updatedDetails = selectedAccountDetails.map((account) => {
      if (account.account_or_corporate_id === accountId) {
        const updatedContractTypeOption = { ...account.contract_type_options }
        updatedContractTypeOption[field] = e.target.checked
        dispatch(setIsCheckedState(updatedContractTypeOption[field]))
        return {
          ...account,
          is_checked: e.target.checked,
          accountId,
          contractType,
          contract_type_options: updatedContractTypeOption
        }
      }
      return {
        ...account,
        contractType,
        accountId
      }
    })
    dispatch(setcontractTypeCheckBox(field))
    dispatch(setContractTypeState(!contractTypeState))
    setSelectedAccountDetails(updatedDetails)
  }
  const handleSelectAllChange = (e, field) => {
    const contractType = contractTypesOptions.filter((contracttype) => contracttype.label == field)
    const updatedDetails = selectedAccountDetails.map((account) => {
      // if (account.default_contract_type !== field || account.default_contract_type == undefined) {
      const updatedContractTypeOption = { ...account.contract_type_options }
      updatedContractTypeOption[field] = e.target.checked || account.default_contract_type === field
      dispatch(setIsCheckedState(updatedContractTypeOption[field]))
      return {
        ...account,
        contractType,
        is_checked: e.target.checked,
        contract_type_options: updatedContractTypeOption
      }
      // }
      // return account;
    })
    setSelectedAccountDetails(updatedDetails)
    dispatch(setcontractTypeCheckBox('All'))
    dispatch(setContractTypeState(!contractTypeState))
  }

  const renderSelectAllCheckbox = (field, title) => {
    let anyAllSelected = false
    const selectAllMapping = {}
    if (selectedAccountDetails?.length > 0) {
      const contractTypes = Object.keys(selectedAccountDetails[0]?.contract_type_options)
      contractTypes.forEach((contractType) => {
        selectAllMapping[contractType] = true
      })
      selectedAccountDetails.forEach((accountDetail) => {
        contractTypes.forEach((contractType) => {
          if (!accountDetail.contract_type_options[contractType]) {
            selectAllMapping[contractType] = false
          }
        })
      })

      contractTypes.forEach((contractType) => {
        if (selectAllMapping[contractType]) {
          anyAllSelected = true
        }
      })
    }
    const isDefaultAll = selectedAccountDetails?.every(
      (account) => account.default_contract_type === field
    )
    const contractTypeID = contractTypesIds?.filter((val) => val['label'] === field)[0]['value']
    const allChecked =
      allSelectedContractTypes?.length > 0
        ? allSelectedContractTypes?.filter((val) => val[0] === contractTypeID)[0][1]
        : false

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          checked={allChecked}
          onChange={(e) => handleSelectAllChange(e, field)}
          disabled={
            isDefaultAll ||
            (scenarioType === 'National' &&
              (dataSource === 'RME' || (anyAllSelected && !selectAllMapping[field])))
          }
        />
        <span style={{ marginLeft: '8px' }}>{title}</span>
      </div>
    )
  }

  const handleMergeCheckboxChange = (e, accountId) => {
    const updatedDetails = selectedAccountDetails.map((account) => {
      if (account.account_or_corporate_id === accountId) {
        return { ...account, mergeAccountCheckBox: e.target.checked }
      }
      return account
    })
    setSelectedAccountDetails(updatedDetails)
  }

  const handleMergeSelectAllChange = (e) => {
    const updatedDetails = selectedAccountDetails.map((account) => ({
      ...account,
      mergeAccountCheckBox: e.target.checked
    }))
    setSelectedAccountDetails(updatedDetails)
    dispatch(setMergeAll(true))
  }

  const renderMergeSelectAllCheckbox = () => {
    const allChecked = selectedAccountDetails.every((account) => account.mergeAccountCheckBox)
    return <Checkbox checked={allChecked} onChange={handleMergeSelectAllChange} />
  }

  const handleDelete = (accountId) => {
    const updatedDetails = selectedAccountDetails.filter(
      (account) => account.account_or_corporate_id !== accountId
    )
    const updatedSelectedAccounts = selectedAccounts.filter((id) => id !== accountId)
    setDeSelectedAccount(deSelectedAccount.filter((account) => account !== parseInt(accountId)))

    setSelectedAccountDetails(updatedDetails)
    setRemoveAccountsSelection([accountId])
    setSelectedAccounts(deSelectedAccount.filter((account) => account !== parseInt(accountId)))
    if (updatedDetails?.length == 0) {
      if (paginationDetails.current > 1) {
        paginationOnChange({
          current: paginationDetails.current - 1,
          pageSize: 5
        })
      }
    }

    // setSelectedAccounts([parseInt(accountId)]);
    setUnselect(true)
  }
  const handleOnChange = (pagination, filters, sorter) => {
    paginationOnChange(pagination)
  }
  const columns = [
    {
      title: renderMergeSelectAllCheckbox(),
      dataIndex: 'mergeAccountCheckBox',
      key: 'mergeAccountCheckBox',
      width: '5%',
      render: (_, record) => (
        <Checkbox
          checked={record.mergeAccountCheckBox}
          // disabled={scenarioType === 'National' || record.is_custom_account || record.is_merged_account}
          disabled={scenarioType === 'National' || record.is_merged_account}
          onChange={(e) => handleMergeCheckboxChange(e, record.account_or_corporate_id)}
        />
      )
    },
    {
      title: dataSource === 'RME' ? 'Account' : 'Corporate Parent',
      dataIndex: 'account_or_corporate_name',
      key: 'account_or_corporate_name',
      width: '20%',
      render: (text) => <span>{text}</span>
    },
    ...contractTypesOptions.map((contractTypeOption) => {
      const { label, value } = contractTypeOption
      return {
        title: renderSelectAllCheckbox(label, label),
        dataIndex: label,
        key: label,
        width: '11%',
        render: (_, record) => {
          const nationalDisabled = scenarioType === 'National' && record.default_contract_type
          const nationalMergedDisabled =
            scenarioType === 'National' &&
            !record.default_contract_type &&
            Object.values(record.contract_type_options).some((val) => val === true) &&
            !record.contract_type_options[label]

          return (
            <Checkbox
              checked={record.contract_type_options[label]}
              disabled={
                nationalMergedDisabled ||
                nationalDisabled ||
                record.default_contract_type === label ||
                (dataSource === 'HCOS' && scenarioType === 'National')
              }
              onChange={(e) => handleCheckboxChange(e, record.account_or_corporate_id, label)}
            />
          )
        }
      }
    }),
    {
      title: '',
      key: 'edit_sites',
      width: '20%',
      render: (_, record) => (
        <Button
          style={{
            boxShadow: 'none',
            borderColor: '#00857c',
            borderRadius: '0px'
          }}
          onClick={() =>
            showEditModal(record.account_or_corporate_id, record.account_or_corporate_name)
          }
        >
          {scenarioType === 'National' ? 'View ' : 'Edit '} Sites & Volumes
        </Button>
      )
    },
    {
      title: '',
      key: 'delete',
      width: '5%',
      render: (_, record) => (
        <Button
          style={{
            border: 'none',
            boxShadow: 'none',
            padding: '0',
            margin: '0',
            color: '#00857c'
          }}
          onClick={() => handleDelete(record.account_or_corporate_id)}
        >
          <DeleteOutlined style={{ margin: '0' }} />
        </Button>
      )
    }
  ].filter((column) => {
    if (scenarioType === 'Regular') return true
    return column.key !== 'mergeAccountCheckBox' && column.key !== 'delete'
  })

  return (
    <>
      {selectedAccountDetails.length > 0 && (
        <div>
          <Table
            columns={columns}
            dataSource={selectedAccountDetails}
            rowKey="account_id"
            pagination={{
              pageSize: 5,
              current: paginationDetails?.current || 1,
              total: paginationDetails?.pageCount * 5 || 0,
              showSizeChanger: false
            }}
            onChange={handleOnChange}
            rowClassName="custom-row-style"
            style={{ marginTop: '10px' }}
            className="table-create-scenario-modal"
          />
        </div>
      )}
    </>
  )
}

export default AccountDetailsTable
